import {
  labelNoSource,
  panelLabelUsedSource,
  panelLabelUsedSources,
} from "_constants";
import { SourceTypeChip } from "components/shared";
import { Answer } from "interfaces";

export const SourceTypeChipContainer = ({ answer }: { answer: Answer }) => {
  const numberOfSource =
    (answer?.codesList?.length ?? 0) +
    (answer?.privateSourcesList?.length ?? 0) +
    (answer?.sourcesList?.length ?? 0);

  return (
    <div className="sources-container">
      <span className="italic blue-text">
        {numberOfSource === 0
          ? labelNoSource
          : `${numberOfSource} ${
              numberOfSource === 1
                ? panelLabelUsedSource
                : panelLabelUsedSources
            }`}
      </span>

      <div className="flex-container margin-top-14 gap-6 wrap">
        {answer?.codesList?.map((item, index) => {
          return (
            <SourceTypeChip
              type={item.type}
              name={item.name}
              stateUpdate={item.stateUpdate}
              key={`chip-chode-${index}`}
            />
          );
        })}
        {answer?.sourcesList?.map((item, index) => {
          return (
            <SourceTypeChip
              type={item.type}
              name={item.name}
              stateUpdate={item.stateUpdate}
              key={`source-chode-${index}`}
            />
          );
        })}
        {answer?.privateSourcesList?.map((item, index) => {
          return (
            <SourceTypeChip
              type={item.type}
              name={item.name}
              stateUpdate={item.stateUpdate}
              key={`private-chode-${index}`}
            />
          );
        })}
      </div>
    </div>
  );
};
